var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutlineBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ff391d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521 -693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H40V40H0Z",
    transform: "translate(521 693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,23.667h3.333V27H17Zm0-13.333h3.333v10H17ZM18.65,2A16.667,16.667,0,1,0,35.333,18.667,16.659,16.659,0,0,0,18.65,2Zm.017,30A13.333,13.333,0,1,1,32,18.667,13.33,13.33,0,0,1,18.667,32Z",
    transform: "translate(522.333 694.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutlineBlack24Dp);
export default __webpack_public_path__ + "static/media/error_outline_black_24dp.434d31dc1e7d92ac84fdb33aded7abf9.svg";
export { ForwardRef as ReactComponent };